export default "__VITE_ASSET__CcDsBfal__"